module.exports = __webpack_public_path__ + "img/jun88Logo-1.0d6c31e9.png";